import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {filter, map, switchMap, take} from 'rxjs/operators';
import {configApi} from '@/api/config';
import {currenciesCache$} from './config/currency';
import {numUtil} from '@/helper';

interface CoinChain {
  contractAddress: string;
  chainName: string;
  currency: string;
  shortContractAddress: string;
}

export const pilotCoinsChainCache$ = new ReplaySubject<Map<string, any>>(1);

currenciesCache$
  .pipe(
    filter((o) => o.size > 0),
    switchMap((currenciesCache) => getPilotCoins(currenciesCache)),
    filter(Boolean),
    take(1),
    map((o) => o.reduce((p, item) => p.set(item.currency, item), new Map()))
  )
  .subscribe(pilotCoinsChainCache$);

async function getPilotCoins(currenciesCache) {
  const {data} = await configApi.getPilotCoins();
  if (data) {
    return data.map((o) => {
      const info = currenciesCache.has(o.currency) ? currenciesCache.get(o.currency) : {displayCurrency: o.currency};
      return {
        ...o,
        displayCurrency: info.displayCurrency,
        contractAddress: o.contractAddress || '',
        shortAddress: convertShortAddress(o.contractAddress),
        chainName: o.chainName || '',
        marketCapEv: o.marketCap,
        marketCap: numUtil.abbreviateNumber(Math.floor(o.marketCap)),
      };
    });
  }
  return data;
}
export function convertCurrency(currency, currenciesCache) {
  if (currenciesCache.has(currency)) {
    return currency;
  }
  let currency2 = currency.replace(/^10+/, '');
  if (currenciesCache.has(currency2)) {
    return currency2;
  }
  currency2 = currency.replace(/[0-9]/g, '');
  if (currenciesCache.has(currency2)) {
    return currency2;
  }
  return currency;
}

export function convertShortAddress(address: string) {
  if (!address) {
    return '';
  }
  return address.substring(0, 4) + '....' + address.substring(address.length - 4);
}
